import HomeRouter from '@/views/pages/dashboard/HomeRouter.vue'

export default [
  {
    path: '',
    name: 'home',
    component: HomeRouter,
    meta: {
      pageTitle: 'Home',
      breadcrumb: [
        {
          text: 'Home',
          active: true,
        },
      ],
      resource: 'Home',
    },
  },
]
